import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { SocketActions } from '@store/socketSaga'
import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'

import { useAuth } from '@/hooks'
import { usePrintRender } from '@/hooks/index'

export const useSocket = () => {
  const dispatch = useDispatch()
  const projectId = useSelector(migrationProjectSelector.getProjectId)
  const { isPrinting } = usePrintRender()

  const { authenticated } = useAuth()

  useEffect(() => {
    if (!projectId) {
      return
    }

    if (isPrinting) {
      return
    }

    dispatch(
      SocketActions.subscribe({
        id: projectId,
        authenticated,
      })
    )

    return () => {
      dispatch(SocketActions.unsubscribe({ id: projectId }))
    }
  }, [projectId, authenticated])
}
